import React from 'react';
import PetitionWidget from '../components/PetitionWidget';
import Hero from '../components/Hero';
import FlightBooking from '../components/FlightBooking';
import Introduction from '../components/Introduction';
import Activities from '../components/Activities';
import MediaSection from '../components/MediaSection';
import BecomePilot from '../components/BecomePilot';
import Training from '../components/Training';
import Airfield from '../components/Airfield';
import Aircraft from '../components/Aircraft';
import Events from '../components/Events';
import Contact from '../components/Contact';

const HomePage: React.FC = () => {
  return (
    <>
      <PetitionWidget />
      <Hero />
      <FlightBooking />
      <Introduction />
      <Activities />
      <MediaSection />
      <BecomePilot />
      <Training />
      <Aircraft />
      <Airfield />
      <Events />
      <Contact />
    </>
  );
};

export default HomePage; 